import React from 'react';
import PT from 'prop-types';
import Slider from 'react-slick';
import { colors, spacing } from '@procore/core-react';
import styled from 'styled-components';
import { Slide, ArrowContainer } from '@/react/styles/v2';
import { ArrowNext, ArrowPrev } from '@/react/components/Arrows';

const SlickDots = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  gap: 4px;
  border-radius: 16px;
  padding: ${spacing.md}px;
  margin: 0 auto;
  background-color: ${colors.gray94};
  bottom: -36px;

  @media (min-width: 768px) {
    bottom: -59px;
  }

  & > li {
    margin: 0;
    width: 6px;
    height: 6px;

    &.slick-active {
      width: 8px;
      height: 8px;

      & > button {
        &::before {
          font-size: 8px;
        }
      }
    }

    & > button {
      width: auto;
      height: auto;
      padding: 0;

      &::before {
        width: auto;
        height: auto;
        line-height: 0;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.2s ease;
      }
    }
  }
`;

const StyledSlider = styled(Slider)`
  .slick-track {
    display: flex !important; // have to do this to override css
    align-items: stretch;
  }

  .slick-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;

const SlideContainer = styled.div`
  width: 100%;
  height: 183px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (min-width: 768px) {
    height: 496px;
  }
`;

export const SingleCarousel = ({ settings, slides, handleOnSlideClick }) => {
  const sliderSettings = {
    focusOnSelect: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    adaptiveHeight: false,
    appendDots: (dots) => <SlickDots>{dots}</SlickDots>,
    prevArrow: (
      <ArrowContainer>
        <ArrowPrev />
      </ArrowContainer>
    ),
    nextArrow: (
      <ArrowContainer>
        <ArrowNext />
      </ArrowContainer>
    ),
    ...settings,
  };

  return (
    <StyledSlider {...sliderSettings}>
      {slides?.map((slide, index) => (
        <SlideContainer key={slide.url}>
          <Slide
            src={slide.url}
            onClick={handleOnSlideClick}
            data-testid={`slide-${index}`}
          />
        </SlideContainer>
      ))}
    </StyledSlider>
  );
};

SingleCarousel.propTypes = {
  slides: PT.arrayOf(
    PT.shape({
      url: PT.string.isRequired,
    })
  ).isRequired,
  settings: PT.shape({}),
  handleOnSlideClick: PT.func,
};
